/**
 * Tamaño del tablero cuadrado: el menor entre el ancho y el alto disponibles.
 *
 * @param topbarHeight - Altura de la barra superior + stats en px (por defecto 80)
 */
export function getBoardSize(topbarHeight = 80): string {
  // --vph es el alto real de la ventana (100svh donde se soporta). Con 100vh
  // el tablero se calculaba contra un alto mayor que el visible y empujaba el
  // pad numerico fuera de pantalla en Android, sobre todo en horizontal.
  return `min(calc(var(--vph) - ${topbarHeight}px), 95vw)`;
}

/**
 * Calcula el tamaño de celda para que el tablero ocupe el máximo espacio disponible
 * en pantalla, respetando tanto el ancho como el alto del viewport.
 *
 * @param gridCols - Número de columnas del tablero (incluyendo cabeceras si las hay)
 * @param topbarHeight - Altura aproximada de la barra superior + stats en px (por defecto 80)
 * @returns Valor CSS para width/height de cada celda
 */
export function getBoardCellSize(gridCols: number, topbarHeight = 80): string {
  return `calc(${getBoardSize(topbarHeight)} / ${gridCols})`;
}

/**
 * Calcula el font-size proporcional al tamaño de celda.
 *
 * @param gridCols - Número de columnas del tablero
 * @param ratio - Fracción del tamaño de celda (por defecto 0.5)
 * @param topbarHeight - Altura de la barra superior en px
 */
export function getBoardFontSize(gridCols: number, ratio = 0.5, topbarHeight = 80): string {
  return `calc(${getBoardSize(topbarHeight)} / ${gridCols} * ${ratio})`;
}

/**
 * Tamaño del tablero medido contra SU HUECO, no contra la pantalla.
 *
 * Las versiones de arriba restan a la altura de ventana una constante con lo
 * que ocupan cabecera, barra del juego y pad. Ese número se queda corto en
 * cuanto cambia cualquiera de las tres cosas: al hacer el pad permanente, los
 * 130px de Fillomino dejaron de cubrir los 184 reales y el tablero se salía
 * por arriba y por abajo a la vez.
 *
 * Con unidades de container query el tablero se mide contra el hueco que le
 * deja el flex, así que no hay nada que estimar. Requiere `containerType:
 * 'size'` en el contenedor del tablero.
 */
export const BOARD_FROM_AREA = 'min(100cqw, 100cqh)';

export function getBoardCellSizeFromArea(gridCols: number): string {
  return `calc(${BOARD_FROM_AREA} / ${gridCols})`;
}

export function getBoardFontSizeFromArea(gridCols: number, ratio = 0.5): string {
  return `calc(${BOARD_FROM_AREA} / ${gridCols} * ${ratio})`;
}
